module.exports = __webpack_public_path__ + "img/va.svg";